<template>
    <ui-modal small>
        <template #header>
            <h3 v-text="'Zmiana plomby'" />
        </template>
        <page-preloader v-if="isLoading" min-height="200px" />
        <template v-else>
            <div class="a-infoBar a-infoBar--warning text-sm">
                Zdejmij plombę z worka, załóż nową i wpisz jej numer. Opcjonalnie podaj przyczynę zmiany.
                <strong
                    v-text="`Przytwierdź starą plombę do worka.
                        Jeśli tego nie zrobisz, przewoźnik może odmówić odbioru.`"
                />
            </div>

            <div class="card text-sm text-primary gap-0-5 p-3 my-3 ">
                <div class="row">
                    <span
                        v-text="'Frakcja'"
                        class="font-weight-bold col"
                    />
                    <fraction-label
                        class="text-primary col"
                        :fraction="fraction"
                    />
                </div>

                <div class="row">
                    <span class="col d-flex align-items-center font-weight-bold">
                        Nr plomby
                        <a-icon
                            v-tooltip="'Aktualny numer plomby'"
                            icon="Info"
                            height="16"
                        />
                    </span>
                    <span class="col">
                        {{ bag.seal_number }}
                        <span v-if="operatorName" v-text="`(${ operatorName })`" />
                    </span>
                </div>

                <div class="row">
                    <span class="col d-flex align-items-center font-weight-bold">
                        Wartość worka
                        <a-icon
                            v-tooltip="`Na wartość worka składa się liczba sztuk przemnożona przez opłatę operatora`"
                            icon="Info"
                            height="16"
                        />
                    </span>
                    <span class="col">
                        <strong v-text="total" />
                        ({{ quantity }} szt.)
                    </span>
                </div>
            </div>

            <the-input
                v-model="sealNumber"
                required
                class="mb-3"
                label="Wpisz numer nowej plomby"
                :maxlength="$options.sealNumberMaxLength"
                :text="sealNumber"
                :validation="digitsOnly"
            />
            <seal-number-requirements :requirements="sealRequirements" />

            <the-text-area
                v-model="changeReason"
                class="mt-3"
                label="Opisz powód zmiany (opcjonalnie)"
                style="height: 10rem"
                :maxlength="200"
                :value="changeReason"
            />
        </template>
        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Zamknij"
                :disabled="isLoading"
                @click="$emit('close-modal')"
            />
            <the-btn
                v-tooltip="!sealNumber && 'Wpisz numer nowej plomby'"
                class="btn-secondary"
                text="Zmień plombę"
                :disabled="isLoading || !sealNumber"
                @click="onConfirm"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapActions } from 'vuex'
import { SEAL_NUMBER_VALID_LENGTH } from '@/store/modules/drs/drs-stores-bags.module'
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'

export default {
    sealNumberMaxLength: SEAL_NUMBER_VALID_LENGTH,

    mixins: [bagsMixin],

    data: () => ({
        sealNumber: null,
        changeReason: '',
        isLoading: false
    }),

    created() {
        if (this.args.sealNumber) {
            this.sealNumber = this.args.sealNumber
            this.changeReason = this.args.changeReason
        }
    },

    computed: {
        args() {
            return this.$store.getters.getModal.args
        },

        bag() {
            return this.args.bag
        }
    },

    methods: {
        ...mapActions('drsBags', ['changeSealNumber', 'loadPackages']),

        async onConfirm() {
            this.isLoading = true

            // validate new seal prefix
            if (this.sealWarning) {
                this.isLoading = false
                this.goToSealPrefixWarning()
                return
            }

            // change seal number
            await this.submitSealChange()

            this.isLoading = false
            this.$emit('close-modal')
        },

        async submitSealChange() {
            await this.changeSealNumber({
                changeReason: this.changeReason,
                mcuid: this.bag.mcuid,
                newSealNumber: this.sealNumber,
                oldSealNumber: this.bag.seal_number
            })

            // update packages
            await this.loadPackages()
        },

        goToSealPrefixWarning() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/stores/bags/SealPrefixWarning',
                args: {
                    ...this.args,
                    sealNumber: this.sealNumber,
                    changeReason: this.changeReason,
                    onAcceptBtn: () => this.submitSealChange(),
                    onRejectBtn: (args) => {
                        this.$store.dispatch('openModal', {
                            componentPath: 'drs/stores/bags/EditBag',
                            args
                        })
                    }
                }
            })
        }
    }
}
</script>